import { IconFont, Text } from '@byecode/ui'
import { Link } from 'react-router-dom'

import { Card } from './Card'

export const NotAllow = () => {
    return (
        <Card title={<IconFont size={60} type="DisableAnalysis" />}>
            <Text size={20} lineHeight="28px" weight={600} mb={12}>
                应用分析功能已停用
            </Text>
            <Text lineHeight="22px" size={14}>
                由于应用已开启了“自定义域名”，应用分析的功能已停用。代替的方案是使用
                <Link to="../settings" style={{ color: 'var(--color-main)' }}>
                    {'“应用分析>绑定自有统计”'}
                </Link>
                的功能，通过第三方统计平台来收集数据。
            </Text>
        </Card>
    )
}
